import { render } from "./CompaniesHeader.vue?vue&type=template&id=1b3626de"
import script from "./CompaniesHeader.vue?vue&type=script&lang=js"
export * from "./CompaniesHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__